import { render, staticRenderFns } from "./ProjectResultConfigItemList.vue?vue&type=template&id=876cdd3c&scoped=true"
import script from "./ProjectResultConfigItemList.vue?vue&type=script&lang=js"
export * from "./ProjectResultConfigItemList.vue?vue&type=script&lang=js"
import style0 from "./ProjectResultConfigItemList.vue?vue&type=style&index=0&id=876cdd3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "876cdd3c",
  null
  
)

export default component.exports